export default {
  nav: {
    main: 'Główna',
    ordersAndInvoices: 'Zamówienia i faktury',
    drafts: 'Wersje robocze',
    automation: 'Automatyzacja',
    workspace: 'Przestrzeń robocza',
    templates: 'Szablony',
    delivery: 'Dostawa',
    settings: 'Ustawienia',
    shippingLabels: 'Etykiety wysyłkowe',
    subscriptions: 'Subskrypcje',
    support: 'Wsparcie',
    developer: 'Deweloper',
    writeReview: 'Napisz recenzję',
    supportTicket: 'Zgłoszenie do wsparcia',
    welcomeTour: 'Przewodnik powitalny',
    administratorConsole: 'Konsola administratora',
    logout: 'Wyloguj',
  },
  dashboard: {
    pageTitle: 'Zamówienia i faktury',
    pageDescription: 'Manage your orders and invoices',
    title: 'Zamówienia i faktury',
    selectedOrders: '{count} wybranych zamówień',
    completed: '% ukończono',
    processing: 'Przetwarzanie, proszę czekać...',
    bulkDownload: 'Pobieranie zbiorcze',
    upgradeBulkDownload: 'Ulepsz plan, aby pobrać zbiorczo',
    showFilters: 'Pokaż filtry',
    hideFilters: 'Ukryj filtry',
    creatingInvoices: 'Tworzenie faktur, proszę czekać...',
    bulkCreateInvoices: 'Zbiorcze tworzenie faktur',
    cannotCreateAutopilot: 'Nie można ręcznie tworzyć faktur, gdy tryb fakturowania jest na autopilocie.',
    exportInvoices: 'Eksportuj faktury lub zamówienia',
    capturePayments: 'Ręczne przechwytywanie płatności',
    filterOrders: 'Filtruj zamówienia',
    error: 'Hej, coś poszło nie tak...',
    close: 'Zamknij',
    chooseDate: 'Wybierz datę',
    chooseIssueDate: 'Wybierz datę wystawienia dla wybranych faktur',
    cancel: 'Anuluj',
    createInvoices: 'Utwórz faktury',
    storno: 'Storno',
    bulkOrderCapture: 'Zbiorcze przechwytywanie zamówień',
  },
  search: {
    createdBetween: 'Utworzone między',
    modifiedBetween: 'Zmodyfikowane między',
    orderNumber: 'Nr zamówienia',
    invoiceNumber: 'Nr faktury',
    refundNumber: 'Nr zwrotu',
    customer: 'Klient',
    payment: 'Płatność',
    any: 'Dowolna',
    authorized: 'Autoryzowane',
    pending: 'Oczekujące',
    paid: 'Opłacone',
    partiallyPaid: 'Częściowo opłacone',
    refunded: 'Zwrócone',
    voided: 'Anulowane',
    partiallyRefunded: 'Częściowo zwrócone',
    unpaid: 'Nieopłacone',
    fulfillment: 'Realizacja',
    fulfilled: 'Zrealizowane',
    partial: 'Częściowe',
    unfulfilled: 'Niezrealizowane',
    loading: 'Ładowanie zamówień...',
    search: 'Szukaj',
  },
  orderList: {
    noCustomer: 'Brak klienta',
    downloadOrder: 'Pobierz zamówienie',
    deleteWarning: 'Uwaga! Spowoduje to usunięcie wszystkich faktur i zwrotów utworzonych po dacie:',
    includingInvoice: 'łącznie z wybraną fakturą nr',
    pressOk: 'Naciśnij OK, aby kontynuować, lub Anuluj, aby przerwać.',
    cannotCreateAutopilot: 'Nie można ręcznie tworzyć faktur, gdy tryb fakturowania jest na autopilocie.',
    createInvoice: 'Utwórz fakturę dla tego zamówienia',
    create: 'Utwórz',
    addCreditNote: 'Dodaj notę kredytową',
    createStorno: 'Utwórz fakturę storno',
    refund: 'Zwrot',
    downloadInvoice: 'Pobierz tę fakturę',
    download: 'Pobierz',
    default: 'Domyślny',
    downloadStorno: 'Pobierz tę fakturę storno/notę kredytową',
    fulfillOrder: 'Zrealizuj zamówienie',
    orderNum: 'Nr zamówienia',
    locPrefix: 'Prefiks lokalizacji',
    invoiceNum: 'Nr faktury',
    refundNum: 'Nr zwrotu',
    customerCol: 'Klient',
    orderCreatedDate: 'Data utworzenia zamówienia',
    orderModifiedDate: 'Data modyfikacji zamówienia',
    delivered: 'Dostarczono',
    paymentStatus: 'Status płatności',
    fulfillmentStatus: 'Status realizacji',
    totalOutstanding: 'Łączna kwota zaległa',
    originalPrice: 'Cena pierwotna',
    noOrders: 'Twój sklep nie ma zamówień o wybranym statusie.',
    cannotCreateNoOrders: 'Nie można tworzyć faktur, gdy nie ma zamówień.',
    createOrdersFirst: 'Utwórz przynajmniej jedno zamówienie i spróbuj ponownie.',
    createOrders: 'Utwórz zamówienia',
    loadingOrders: 'Ładowanie...',
    paidManual: 'Opłacone - Ręcznie',
    paid: 'Opłacone',
    refunded: 'Zwrócone',
    pending: 'Oczekujące',
    partiallyPaid: 'Częściowo opłacone',
    partiallyRefunded: 'Częściowo zwrócone',
    fulfilled: 'Zrealizowane',
    unfulfilled: 'Niezrealizowane',
    deliveryPending: 'Oczekujące',
    deliverNow: 'Dostarcz teraz',
    deliveryPartial: 'Częściowa',
    notDelivered: 'Niedostarczone',
    deliverAgain: 'Dostarcz ponownie',
    deliveryDetails: 'Szczegóły dostawy',
    deliveryFailed: 'Dostawa nieudana',
    sent: 'Wysłane',
    failed: 'Nieudane',
    toLabel: 'Do',
    folderLabel: 'Folder',
    open: 'Otwarte',
    invoice: 'Faktura',
    creditNote: 'Nota kredytowa',
    stornoLabel: 'Storno',
    unknown: 'Nieznane',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet klientów',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Przywróć do tej daty',
    add: 'Dodaj',
    close: 'Zamknij',
  },
  downloadDialog: {
    downloadType: 'Pobierz {type}...',
    selectTemplate: 'Wybierz szablon z galerii, aby wyeksportować zamówienia, faktury, faktury storno lub noty kredytowe.',
    getMoreTemplates: 'Pobierz więcej szablonów',
    createNewTemplate: 'Utwórz nowy szablon',
    allCreatedBetween: 'Wszystkie utworzone {type} między',
    selectedType: 'Wybrane {type}',
    and: 'i',
    status: 'Status',
    any: 'Dowolny',
    open: 'Otwarty',
    closed: 'Zamknięty',
    cancelled: 'Anulowany',
    paymentStatus: 'Status płatności',
    fulfillmentStatus: 'Status realizacji',
    fulfilled: 'Zrealizowane',
    partial: 'Częściowe',
    unfulfilled: 'Niezrealizowane',
    authorized: 'Autoryzowane',
    pending: 'Oczekujące',
    paid: 'Opłacone',
    partiallyPaid: 'Częściowo opłacone',
    refunded: 'Zwrócone',
    voided: 'Anulowane',
    partiallyRefunded: 'Częściowo zwrócone',
    unpaid: 'Nieopłacone',
    format: 'Format',
    forLocation: 'Dla lokalizacji',
    advancedOptions: 'Opcje zaawansowane',
    exportHSCodes: 'Eksportuj kody HS inwentarza (wolniej)',
    noteChrome: 'Uwaga: Dla optymalnego pobierania zalecany jest Chrome i wyłączenie blokera reklam.',
    downloadIndividually: 'Pobierz pojedynczo',
    downloadGrouped: 'Pobierz grupowo',
  },
  templates: {
    pageTitle: 'Szablony',
    pageDescription: 'Customize your invoice templates',
    title: 'Szablony',
    installTranslated: 'Zainstaluj przetłumaczony szablon',
    installTranslatedDesc: 'Wybierz inny język, klikając ten przycisk.',
    createNew: 'Utwórz nowy szablon w razie potrzeby',
    createNewDesc: 'Kliknij ten przycisk, aby utworzyć nowy szablon, jeśli potrzebujesz.',
    customize: 'Dostosuj szablony',
    customizeDesc: 'Kliknij domyślny szablon, aby go dostosować. Możesz zmienić logo, kolory, a bardziej zaawansowani użytkownicy mogą edytować kod.',
    defaultTemplate: 'Faktura, storno i nota kredytowa (Domyślne)',
    logo: 'Logo',
    colorPalette: 'Paleta kolorów',
    getColorPalettes: 'Pobierz palety kolorów',
    paperSize: 'Rozmiar papieru',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientacja',
    landscape: 'Pozioma',
    portrait: 'Pionowa',
    margin: 'Margines (cm)',
    unsavedChanges: 'Niezapisane zmiany',
    discard: 'Odrzuć',
    save: 'Zapisz',
  },
  labels: {
    pageTitle: 'Etykiety wysyłkowe',
    pageDescription: 'Create and manage shipping labels',
    title: 'Etykiety wysyłkowe',
    glsRequiresPro: 'Etykiety wysyłkowe GLS dla EEU wymagają planu Professional.',
    upgradeDesc: 'Ulepsz do planu Professional, aby tworzyć i zarządzać etykietami wysyłkowymi.',
    upgradePlan: 'Ulepsz swój plan',
    eeuGls: 'EEU GLS',
    enabled: 'Włączone',
    country: 'Kraj',
    hungary: 'Węgry',
    slovakia: 'Słowacja',
    czech: 'Czechy',
    romania: 'Rumunia',
    slovenia: 'Słowenia',
    croatia: 'Chorwacja',
    senderId: 'ID nadawcy',
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    name: 'Nazwa',
    city: 'Miasto',
    address: 'Adres',
    zipCode: 'Kod pocztowy',
    contactPerson: 'Osoba kontaktowa',
    phone: 'Telefon',
    email: 'Email',
    glsServices: 'Usługi GLS',
    expressService: 'Usługa ekspresowa',
    exchangeService: 'Usługa wymiany',
    smsService: 'Usługa SMS',
    smsText: 'Treść SMS',
    preAdviceService: 'Usługa PreAdvice',
    unsavedChanges: 'Niezapisane zmiany',
    discard: 'Odrzuć',
    save: 'Zapisz',
  },
  billing: {
    pageTitle: 'Płatności',
    pageDescription: 'Manage your subscription and billing',
    title: 'Płatności',
    subscriptionFor: 'Plan subskrypcji dla sklepu',
    currentlySubscribed: 'Aktualnie subskrybujesz plan',
    plan: 'plan',
    cancelSubscription: 'Anuluj subskrypcję',
    upgradePlan: 'Ulepsz swój plan',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / miesiąc',
    upgrade: 'Ulepsz',
    includesAllStarter: 'Zawiera wszystkie funkcje Starter, a ponadto:',
    proFeature1: 'Globalny pakiet zgodności: prefiksy lokalizacyjne i niestandardowe numerowanie sekwencyjne',
    proFeature2: 'Inteligentna lokalizacja: automatycznie tłumaczone e-maile i zlokalizowane załączniki PDF',
    proFeature3: 'Pełny cykl dokumentów B2B: proformy, oferty B2B i noty kredytowe',
    proFeature4: 'Synchronizacja księgowości B2B: 3-cyfrowa precyzja jednostkowa i wyświetlanie wielowalutowe',
    proFeature5: 'Automatyczne kopie zapasowe: kopiowanie faktur na bezpieczny serwer FTP lub Google Drive',
    proFeature6: 'Shopify Flow: automatyzacja generowania, dostawy i stornowania faktur za pomocą wyzwalaczy i akcji Flow',
    proFeature7: 'Zaawansowana logika AI: wykorzystaj AI na urządzeniu do złożonych warunkowych klauzul układu',
    proFeature8: 'Eksport UBL XML i ZUGFeRD / Factur-X (zgodność z europejskim e-fakturowaniem)',
    proFeature9: 'Kody EPC QR do natychmiastowych płatności mobilnych POS',
    proFeature10: 'Etykiety wysyłkowe GLS dla EEU',
    proFeature11: '7-letnie przechowywanie podatkowe zgodne z przepisami',
    currentlyUsing: 'Aktualnie korzystasz z naszego',
    free: 'darmowego',
    subscriptionPlan: 'planu subskrypcji.',
    monthlyUsage: 'Miesięczne użycie',
    monthlyGenerated: '{count} / 50 faktur w tym miesiącu',
    monthlyLimitReached: 'Osiągnięto limit miesięczny. Ulepsz do planu Starter, aby mieć nieograniczoną liczbę faktur.',
    freePlan: 'Plan darmowy',
    freeToInstall: 'Bezpłatna instalacja',
    freeFeature1: 'Do 50 faktur/zamówień miesięcznie',
    freeFeature2: 'Dostęp do wszystkich 31+ predefiniowanych szablonów',
    freeFeature3: 'Podstawowy AI Copilot',
    freeFeature4: 'Standardowe pobieranie i drukowanie PDF',
    freeFeature5: 'Standardowy pakiet dokumentów (faktury, listy przewozowe, paragony)',
    freeFeature6: '3-miesięczne bezpieczne przechowywanie faktur',
    starterPlan: 'Plan Starter',
    starterPrice: '$9.99 / miesiąc',
    starterPricePerInvoice: '+ 3¢ za każdą utworzoną fakturę',
    subscribe: 'Subskrybuj',
    starterFeature1: 'Nieograniczone faktury i zamówienia',
    starterFeature2: 'Automatyczna dostawa PDF e-mailem',
    starterFeature3: 'Pełny dostęp do edytora hybrydowego i AI Copilot',
    starterFeature4: 'Integracja z Shopify POS i kodami kreskowymi',
    starterFeature5: 'Shopify Flow: wyzwalacze i akcje do automatyzacji faktur',
    starterFeature6: 'Eksport UBL XML / PEPPOL i ZUGFeRD / Factur-X (zgodność z e-fakturowaniem)',
    starterFeature7: '1-roczne bezpieczne przechowywanie faktur',
    proTaxOverrides: 'Niestandardowe nadpisanie podatków: VAT / GST per produkt i stawki na poziomie SKU',
    unsavedChanges: 'Niezapisane zmiany',
    discard: 'Odrzuć',
    save: 'Zapisz',
  },
  autopilot: {
    pageTitle: 'Automatyzacja',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatyzacja',
    autoCreate: 'Automatycznie twórz faktury',
    disabled: 'Wyłączone (ręczne)',
    whenCreated: 'Gdy zamówienia są tworzone',
    whenFulfilled: 'Gdy zamówienia są realizowane',
    whenPaid: 'Gdy zamówienia są opłacone',
    autoCreateDesc: 'Faktury będą tworzone w dniu, w którym zamówienia są tworzone, realizowane lub opłacone.',
    autoStorno: 'Automatycznie twórz faktury storno',
    whenCancelled: 'Gdy zamówienia są anulowane lub zwrócone',
    autoStornoDesc: 'Faktury storno będą tworzone w dniu, w którym zamówienia są anulowane lub tworzone są zwroty.',
    cannotAutoFree: 'Automatyczne tworzenie faktur nie jest dostępne w planie darmowym.',
    upgradePlan: 'Ulepsz swój plan',
    unsavedChanges: 'Niezapisane zmiany',
    discard: 'Odrzuć',
    save: 'Zapisz',
  },
  delivery: {
    pageTitle: 'Dostawa',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Dostawa',
    settings: 'Ustawienia',
    useOrderNumbers: 'Używaj numerów zamówień dla plików',
    sendIfCountry: 'Wyślij, jeśli kraj adresu rozliczeniowego to',
    countryCodesHint: 'Wymień wszystkie kody krajów oddzielone średnikiem.',
    sendForTags: 'Wyślij dla klientów, którzy mają jeden z wymienionych tagów',
    tagsHint: 'Wymień wszystkie tagi oddzielone średnikiem.',
    emailDelivery: 'Dostawa e-mail',
    sendAsPdf: 'Wyślij faktury jako załączniki PDF do klientów',
    autoSend: 'Automatycznie wyślij po utworzeniu faktury',
    subject: 'Temat',
    body: 'Treść',
    xmlAttachments: 'Załączniki XML',
    attachUbl: 'Dołącz UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Dołącz ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Wyślij testowy e-mail',
    sending: 'Wysyłanie...',
    customSmtp: 'Niestandardowy serwer SMTP',
    customSmtpDesc: 'Użyj własnego serwera pocztowego zamiast domyślnego',
    enableSmtp: 'Włącz niestandardowy SMTP',
    smtpHost: 'Host SMTP',
    port: 'Port',
    useSsl: 'Użyj SSL/TLS',
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    fromEmail: 'E-mail nadawcy',
    fromName: 'Nazwa nadawcy',
    shopifyLiquid: 'Szablon Shopify Liquid',
    pasteInto: 'Wklej to do swojego',
    orderConfirmation: 'szablonu potwierdzenia zamówienia',
    toAddLink: 'aby dodać link do pobrania.',
    downloadInvoice: 'Pobierz swoją fakturę',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Wysyłaj żądania do ClientsTablet, gdy tworzone są faktury',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Wysyłaj faktury PDF jako dokumenty celne do ShippyPro dla krajów spoza UE',
    ftpBackup: 'Kopia zapasowa FTP / SFTP',
    ftpDesc: 'Automatycznie kopiuj faktury na swój serwer',
    enableFtp: 'Włącz automatyczną kopię zapasową FTP',
    host: 'Host',
    useSftp: 'Użyj SFTP (bezpieczne)',
    destinationFolder: 'Folder docelowy',
    xmlFiles: 'Pliki XML',
    includeUbl: 'Dołącz UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Dołącz ZUGFeRD / Factur-X XML',
    testConnection: 'Testuj połączenie',
    testing: 'Testowanie...',
    pro: 'PRO',
    upgradeFtp: 'Ulepsz do planu Professional, aby automatycznie kopiować faktury na serwer FTP/SFTP.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Synchronizuj faktury automatycznie z dyskiem',
    connected: 'Połączono',
    disconnect: 'Rozłącz',
    notWorking: 'Nie działa? Przejdź do',
    googlePermissions: 'Uprawnienia Google',
    removeThenReconnect: 'usuń Invoice Browse, a następnie połącz ponownie.',
    connectGoogleDrive: 'Połącz Google Drive',
    upgradeGoogleDrive: 'Ulepsz do planu Professional, aby automatycznie synchronizować faktury z Google Drive.',
    unsavedChanges: 'Niezapisane zmiany',
    discard: 'Odrzuć',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Zapisz',
  },
  bookkeeping: {
    pageTitle: 'Ustawienia',
    pageDescription: 'Configure your invoice settings',
    title: 'Ustawienia',
    owner: 'Właściciel',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Zachowaj odrębną numerację faktur dla każdej lokalizacji zamówienia',
    keepDifferentNumberingDisabled: 'Odrębna numeracja faktur dla każdej lokalizacji zamówienia nie jest dostępna w Twoim planie.',
    locationEmailDesc: 'Pozwala to na wysyłanie e-maili i faktur przetłumaczonych na podstawie lokalizacji zamówienia: lokalizacji magazynu, adresu wysyłki lub adresu rozliczeniowego',
    upgradePlan: 'Ulepsz swój plan',
    matchingCriteria: 'Kryteria dopasowania',
    locationId: 'ID lokalizacji',
    shippingCountryCode: 'Kod kraju adresu wysyłki',
    billingCountryCode: 'Kod kraju adresu rozliczeniowego',
    matchLocationDesc: 'Dopasuj lokalizację na podstawie ID lokalizacji zamówienia, kodu kraju adresu wysyłki lub rozliczeniowego.',
    companyInfo: 'Informacje o firmie',
    name: 'Nazwa',
    website: 'Strona internetowa',
    registrationNumber: 'Numer rejestracyjny',
    taxId: 'NIP',
    addressSection: 'Adres',
    streetName: 'Nazwa ulicy',
    streetNumber: 'Numer domu',
    zip: 'Kod pocztowy',
    city: 'Miasto',
    region: 'Region',
    country: 'Kraj',
    bankingInfo: 'Informacje bankowe',
    bankName: 'Nazwa banku',
    swift: 'Swift',
    currency: 'Waluta',
    iban: 'IBAN',
    invoicing: 'Fakturowanie',
    decimalPlaces: 'Miejsca dziesiętne',
    invoicesPrefix: 'Prefiks faktur',
    currentInvoiceNumber: 'Aktualny numer faktury',
    creditNotesPrefix: 'Prefiks not kredytowych',
    currentCreditNoteNumber: 'Aktualny numer noty kredytowej',
    lastInvoiceDate: 'Data ostatniej faktury',
    noInvoicesYet: 'Nie utworzono jeszcze żadnych faktur.',
    confirmReverting: 'Potwierdź cofnięcie systemu',
    allInvoicesAfter: 'Wszystkie faktury i ich storna wystawione po',
    willBeRemoved: 'zostaną usunięte. Kontynuować cofanie systemu?',
    cancel: 'Anuluj',
    revert: 'Cofnij',
    revertDesc: 'Cofnięcie systemu usunie wszystkie faktury utworzone po wybranej dacie.',
    revertToDate: 'Cofnij do tej daty',
    reverting: 'Cofanie systemu, proszę czekać...',
    useOrderNumbering: 'Użyj numeracji zamówień',
    showVat: 'Pokaż VAT na fakturach',
    overrideTaxes: 'Nadpisz podatki',
    pricesIncludeTax: 'Ceny zawierają podatek',
    productsTaxRate: 'Stawka podatkowa produktów',
    shippingTaxRate: 'Stawka podatkowa wysyłki',
    skusSeparated: 'SKU oddzielone średnikiem',
    skusTaxRate: 'Stawka podatkowa SKU',
    useOrderDates: 'Użyj dat utworzenia zamówień dla faktur',
    convertCurrency: 'Przelicz ceny na walutę, w której płaci klient',
    unsavedChanges: 'Niezapisane zmiany',
    discard: 'Odrzuć',
    save: 'Zapisz',
  },
  drafts: {
    pageTitle: 'Wersje robocze',
    pageDescription: 'Manage your draft orders',
    title: 'Wersje robocze',
    download: 'Pobierz',
    newDraft: 'Nowa wersja robocza',
    exporting: 'Eksportowanie {status}%...',
    accessNotGranted: 'Dostęp do wersji roboczych zamówień nie został przyznany. Proszę',
    reLogin: 'zaloguj się ponownie',
    toGrantPermissions: 'aby przyznać wymagane uprawnienia "Wersje robocze zamówień".',
    pushFailed: 'Wysyłanie do Shopify nie powiodło się:',
    exportError: 'Błąd eksportu:',
    confirmDelete: 'Czy na pewno chcesz usunąć tę wersję roboczą?',
    incompleteCustomer: 'Dane klienta są niekompletne:',
    pushWithoutCustomer: 'Wersja robocza zostanie wysłana do Shopify bez danych klienta. Kontynuować?',
    customerNotInShopify: 'Ten klient nie istnieje jeszcze w Shopify.',
    warnings: 'Ostrzeżenia:',
    createCustomerAndPush: 'Utworzyć klienta w Shopify i wysłać wersję roboczą zamówienia?',
    downloadTitle: 'Pobierz szkice',
    cancel: 'Anuluj',
  },
  draftEdit: {
    number: "Numer",
    prefix: "Prefiks",

    newDraft: 'Nowa wersja robocza',
    editDraft: 'Edytuj wersję roboczą',
    viewInShopify: 'Zobacz w Shopify',
    back: 'Wstecz',
    createDraft: 'Utwórz wersję roboczą',
    saveChanges: 'Zapisz zmiany',
    documentType: 'Typ dokumentu',
    draftOrder: 'Zamówienie robocze',
    quote: 'Oferta',
    proforma: 'Proforma',
    manualInvoice: 'Faktura ręczna',
    currency: 'Waluta',
    expiryDate: 'Data ważności',
    status: 'Status',
    draft: 'Wersja robocza',
    sent: 'Wysłane',
    accepted: 'Zaakceptowane',
    customer: 'Klient',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    email: 'Email',
    phone: 'Telefon',
    company: 'Firma',
    taxId: 'NIP',
    billingAddress: 'Adres rozliczeniowy',
    address: 'Adres',
    aptSuite: 'Mieszkanie/Lokal',
    city: 'Miasto',
    province: 'Województwo',
    countryField: 'Kraj',
    zip: 'Kod pocztowy',
    shippingAddress: 'Adres wysyłki',
    sameAsBilling: 'Taki sam jak rozliczeniowy',
    lineItems: 'Pozycje',
    shipping: 'Wysyłka',
    shippingTitle: 'Tytuł',
    shippingPlaceholder: 'np. Wysyłka standardowa',
    price: 'Cena',
    note: 'Notatka',
    notePlaceholder: 'Wewnętrzna notatka lub wiadomość do klienta...',
    summary: 'Podsumowanie',
    subtotal: 'Suma częściowa',
    discounts: 'Rabaty',
    tax: 'Podatek',
    total: 'Łącznie',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Wprowadź adres swojego sklepu',
    loginWith: 'Zaloguj się przez',
    createAccount: 'Utwórz nowe konto',
    placeholder: 'nazwa-twojego-sklepu',
    shopRequired: 'Nazwa sklepu jest wymagana',
    login: 'Zaloguj się',
    shopify: 'Shopify',
    terms: 'Regulamin',
    privacy: 'Polityka prywatności',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Podoba Ci się Invoice Browse?',
    description: 'Utworzyłeś swoje pierwsze faktury! Jeśli aplikacja jest dla Ciebie przydatna, krótka recenzja w Shopify App Store bardzo nam pomoże.',
    reward: 'W podziękowaniu zresetujemy Twój miesięczny licznik użycia do 0',
    leaveReview: 'Zostaw recenzję',
    maybeLater: 'Może później',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Witaj w Invoice Browse',
    welcomeContent: 'Pozwól, że pokażę Ci, jak możesz z niej korzystać.',
    dashboardTitle: 'Panel główny',
    dashboardContent: 'Ekran, który widzisz, to główny panel. Tutaj znajdziesz wszystkie zamówienia i możesz je eksportować do różnych typów dokumentów, takich jak: faktury, listy przewozowe i inne.',
    automationTitle: 'Ułatw sobie życie',
    automationContent: 'Włącz automatyzację, aby tworzyć faktury za każdym razem, gdy zamówienia są opłacone lub zwrócone.',
    templatesTitle: 'Dostosuj szablony',
    templatesContent: 'Wejdź tutaj, aby przetłumaczyć swój szablon, dostosować go lub utworzyć nowy.',
    deliveryTitle: 'Dostawa',
    deliveryContent: 'Skonfiguruj naszą aplikację, aby automatycznie kopiować utworzone dokumenty na FTP, Google Drive lub jako załączniki do e-maili.',
    settingsTitle: 'Ustawienia',
    settingsContent1: 'Dostosuj numer telefonu firmy, e-mail i inne pola używane w dokumentach.',
    settingsContent2: 'Zmień numer początkowy dokumentu lub usuń dokumenty utworzone po wybranej dacie.',
    settingsContent3: 'Nadpisz stawki VAT dla wysyłki i produktów',
    settingsContent4: 'Zmień liczbę miejsc dziesiętnych',
    reviewTitle: 'Napisz recenzję',
    reviewContent: 'Wesprzyj nasz zespół, pisząc nam dobrą recenzję!',
    tourTitle: 'Przewodnik powitalny',
    tourContent: 'Hej, możesz otworzyć ten przewodnik ponownie stąd.',
    createDocTitle: 'Utwórz swój pierwszy dokument',
    createDocContent: 'Kliknij przycisk Utwórz, aby utworzyć swój pierwszy dokument.',
    docNumberTitle: 'Numer dokumentu',
    docNumberContent: 'Pierwszy dokument ma przypisany numer 1. Jeśli chcesz zacząć od innego numeru, możesz to zmienić w Ustawieniach.',
    downloadDocTitle: 'Pobierz dokument',
    downloadDocContent: 'Kliknij menu rozwijane Pobierz i wybierz szablon dokumentu, aby wyeksportować zamówienie jako PDF.',
  },
  common: {
    save: 'Zapisz',
    cancel: 'Anuluj',
    close: 'Zamknij',
    discard: 'Odrzuć',
    delete: 'Usuń',
    edit: 'Edytuj',
    create: 'Utwórz',
    loading: 'Ładowanie...',
    unsavedChanges: 'Niezapisane zmiany',
    upgradePlan: 'Ulepsz swój plan',
  },
  languageSelector: {
    label: 'Język',
    auto: 'Automatyczne wykrywanie',
  },
  draftList: {
    draftNum: 'Szkic #',
    shopifyId: 'Shopify ID',
    type: 'Typ',
    customer: 'Klient',
    total: 'Suma',
    status: 'Status',
    delivered: 'Dostarczono',
    date: 'Data',
    actions: 'Akcje',
    noCustomer: 'Brak klienta',
    noDrafts: 'Nie znaleziono szkiców ani wycen.',
    loading: 'Ładowanie...',
    download: 'Pobierz',
    default: 'Domyślny',
    pending: 'Oczekujące',
    deliverNow: 'Dostarcz teraz',
    deliveryDetails: 'Szczegóły dostawy',
    sent: 'Wysłano',
    failed: 'Niepowodzenie',
    deliverAgain: 'Dostarcz ponownie',
    partial: 'Częściowo',
    notDelivered: 'Nie dostarczono',
    deliveryFailed: 'Dostawa nieudana',
    unknown: 'Nieznany',
    edit: 'Edytuj',
    send: 'Wyślij',
    pushToShopify: 'Wyślij do Shopify',
    complete: 'Zakończ',
    duplicate: 'Duplikuj',
    delete: 'Usuń',
    quote: 'Wycena',
    proforma: 'Proforma',
    draftOrder: 'Zamówienie szkic',
    manualInvoice: 'Faktura ręczna',
  },
  draftSearch: {
    createdBtw: 'Utworzono m.',
    draftNum: 'Szkic #',
    shopifyId: 'Shopify ID',
    customer: 'Klient',
    status: 'Status',
    type: 'Typ',
    delivery: 'Dostawa',
    any: 'Wszystkie',
    draft: 'Szkic',
    sent: 'Wysłano',
    accepted: 'Zaakceptowano',
    expired: 'Wygasło',
    converted: 'Skonwertowano',
    cancelled: 'Anulowano',
    quote: 'Wycena',
    proforma: 'Proforma',
    draftOrder: 'Zamówienie szkic',
    manualInvoice: 'Faktura ręczna',
    delivered: 'Dostarczono',
    notDelivered: 'Nie dostarczono',
    pending: 'Oczekujące',
    search: 'Szukaj',
  },
  draftDownload: {
    title: 'Pobierz szkice i wyceny...',
    selectTemplate: 'Wybierz szablon z galerii, aby wyeksportować szkice, wyceny lub proformy.',
    allDraftsBetween: 'Wszystkie szkice między',
    selectedDrafts: 'Wybrane szkice',
    and: 'i',
    status: 'Status',
    documentType: 'Typ dokumentu',
    any: 'Wszystkie',
    draft: 'Szkic',
    sent: 'Wysłano',
    accepted: 'Zaakceptowano',
    expired: 'Wygasło',
    converted: 'Skonwertowano',
    cancelled: 'Anulowano',
    quote: 'Wycena',
    proforma: 'Proforma',
    draftOrder: 'Zamówienie szkic',
    manualInvoice: 'Faktura ręczna',
    format: 'Format',
    noTemplates: 'Nie znaleziono szablonów',
    noTemplatesForType: 'Nie znaleziono szablonów dla typu dokumentu „{type}".',
    installTemplates: 'Zainstaluj szablony',
    toStartExporting: 'aby rozpocząć eksport.',
    noteChrome: 'Uwaga: Dla optymalnego pobierania zalecana jest przeglądarka Chrome i wyłączenie blokerów reklam.',
    cancel: 'Anuluj',
    downloadIndividually: 'Pobierz pojedynczo',
    downloadGrouped: 'Pobierz grupowo',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Zainstaluj nowy szablon',
    tabStyle: 'Styl',
    tabContent: 'Treść',
    tabTranslations: 'Tłumaczenia',
    tabSettings: 'Ustawienia',
    tabCode: 'Kod',
    tabCopilot: 'Kopilot AI',
    logo: 'Logo',
    colorPalette: 'Paleta kolorów',
    colorText: 'Tekst',
    colorBg: 'Tło',
    colorBorder: 'Obramowanie',
    colorPrimary: 'Główny',
    colorAccent: 'Akcent',
    font: 'Czcionka',
    fontDefault: 'Domyślna (DM Sans)',
    fontSize: 'Rozmiar czcionki',
    fontSizeDefault: 'Domyślny (11.5px)',
    fontSizeCompact: 'Kompaktowy',
    fontSizeSmall: 'Mały',
    fontSizeMediumSmall: 'Średnio-mały',
    fontSizeMedium: 'Średni',
    fontSizeMediumLarge: 'Średnio-duży',
    fontSizeLarge: 'Duży',
    fontSizeExtraLarge: 'Bardzo duży',
    documentTitle: 'Tytuł dokumentu',
    documentTitlePlaceholder: 'np. Faktura, Faktura VAT...',
    noToggleSupport: 'Ten szablon nie obsługuje przełączników. Przełącz na szablon z galerii dla pełnej personalizacji.',
    sections: 'Sekcje',
    shippingAddress: 'Adres dostawy',
    bankPaymentDetails: 'Dane bankowe/płatności',
    paymentStatusBadge: 'Znacznik statusu płatności',
    orderNotes: 'Notatki do zamówienia',
    trackingFulfillment: 'Śledzenie/realizacja',
    termsConditions: 'Regulamin',
    signatureLines: 'Linie podpisu',
    qrCode: 'Kod QR',
    lineItems: 'Pozycje',
    taxColumns: 'Kolumny podatkowe (VAT)',
    productSku: 'SKU produktu',
    productImages: 'Obrazy produktu',
    discountBreakdown: 'Podział rabatów',
    itemWeight: 'Waga pozycji',
    hsCode: 'Kod HS (celny)',
    mergeDiscounts: 'Włącz rabaty w cenę produktu',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Sumy',
    subtotalBeforeTax: 'Suma częściowa (przed podatkiem)',
    taxBreakdownByRate: 'Podział podatku wg stawki',
    shippingCostSeparate: 'Koszt dostawy jako osobna linia',
    dueDate: 'Termin płatności',
    formatting: 'Formatowanie',
    dateFormat: 'Format daty',
    decimalPlaces: 'Miejsca dziesiętne',
    paymentTerms: 'Warunki płatności',
    paymentTermsNone: 'Brak',
    thankYouMessage: 'Wiadomość z podziękowaniem',
    thankYouPlaceholder: 'Dziękujemy za zakupy!',
    countryMatchTitle: 'Użyj tego szablonu, gdy adres dostawy lub rozliczeniowy pasuje do tego kraju',
    addressType: 'Typ adresu',
    addressDisabled: 'Wyłączony',
    addressShipping: 'Adres dostawy',
    addressBilling: 'Adres rozliczeniowy',
    country: 'Kraj',
    anyCountry: 'Dowolny kraj',
    countryMatchDesc: 'Po włączeniu ten szablon będzie automatycznie używany dla zamówień, w których wybrany adres pasuje do wybranego kraju.',
    languagePreset: 'Ustawienie języka',
    selectLanguage: 'Wybierz język...',
    languagePresetDesc: 'Wybranie języka wypełnia wszystkie etykiety poniżej. Następnie możesz dostosować poszczególne pola.',
    paperSize: 'Rozmiar papieru',
    format: 'Format',
    orientation: 'Orientacja',
    portrait: 'Pionowa',
    landscape: 'Pozioma',
    margin: 'Margines (cm)',
    template: 'Szablon',
    templateName: 'Nazwa',
    systemAlias: 'Alias systemowy',
    systemAliasDesc: 'dla tras URL POS/Admin',
    systemAliasNone: 'Brak',
    defaultTemplate: 'Szablon domyślny',
    defaultTemplateDesc: 'Używany dla bezpośrednich linków udostępnianych klientom.',
    posRouteDesc: 'Mapuje na /template/[alias]/receipt.pdf dla integracji POS.',
    documentType: 'Typ dokumentu',
    invoiceCreditNote: 'Faktura + Nota kredytowa',
    order: 'Zamówienie',
    invoiceOnly: 'Tylko faktura',
    quoteEstimate: 'Wycena/Kosztorys',
    proformaInvoice: 'Faktura proforma',
    refund: 'Zwrot',
    stornoInvoice: 'Faktura storno',
    creditNoteOnly: 'Tylko nota kredytowa',
    reportLiquid: 'Raport (tylko Liquid)',
    hideRemovedItems: 'Ukryj usunięte/zwrócone pozycje',
    location: 'Lokalizacja',
    locationEmpty: 'Zostaw puste, aby używać dla wszystkich lokalizacji',
    dangerZone: 'Strefa niebezpieczna',
    dangerZoneDesc: 'Trwale usuń ten szablon z konta.',
    removeTemplate: 'Usuń szablon',
    bodyTemplate: 'Szablon główny',
    bodyTemplateDesc: 'Używa składni Mustache lub Liquid. Kliknij snippet:',
    rowTemplate: 'Szablon wiersza',
    rowTemplateDesc: 'Renderowany raz na pozycję. Kliknij snippet:',
    variableReference: 'Referencja zmiennych',
    formatCode: 'Formatuj kod',
    insert: 'Wstaw',
    copy: 'Kopiuj',
    loadModelContinue: 'Załaduj model i kontynuuj',
    cancel: 'Anuluj',
    copilotPlaceholder: 'Spróbuj: przetłumacz na polski, pokaż kolumny podatkowe, dodaj kod kreskowy...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Cofnij',
    redo: 'Ponów',
    aiThinking: 'AI myśli...',
    proposedChanges: 'Proponowane zmiany',
    applyChanges: 'Zastosuj zmiany',
    dismiss: 'Odrzuć',
    aiEngineReady: 'Silnik AI gotowy',
    loadingAiModel: 'Ładowanie modelu AI...',
    aiEngineOff: 'Silnik AI wyłączony —',
    loadForAdvanced: 'załaduj do zaawansowanej edycji',
    instantCommands: 'tłumaczenie, pokazywanie/ukrywanie sekcji, dodawanie snippetów, zmiana czcionki/kolorów/papieru',
    aiEngineDesc: 'strukturalne edycje HTML, zmiany układu, niestandardowe modyfikacje',
    aiLocalDesc: 'Model działa lokalnie przez WebGPU — żadne dane nie opuszczają przeglądarki.',
    aiUpgradeDesc: 'przejdź na Starter lub Professional, aby odblokować zaawansowaną edycję AI.',
    upgrade: 'Ulepsz',
    loadAiQuestion: 'Załadować silnik AI?',
    loadAiDesc: 'Model AI zostanie pobrany i uruchomiony lokalnie przez WebGPU. Wymaga ~1-3 GB wolnego VRAM/RAM i nowoczesnego GPU.',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/pl.js